/**
 * @returns {Object}
 */
export function get() {
  return this.get('/call-center/operator/');
}
